import { useLocation } from 'react-router-dom';
import AppLayout from './app-layout';
import ShopLayout from './shop-layout';

/**
 * Main Layout component.
 * @returns {JSX.Element} The rendered Main Layout component.
 */
const MainLayout = () => {
  const isShop = useLocation().pathname?.split('/')[1] === 'shop';

  return isShop ? <ShopLayout /> : <AppLayout />;
};

export default MainLayout;
